import { string, traveler as travelerUtils } from '@eti/utils';
export const getTravelers = (order, travelerFormNames, defaultTravelerLabel, travelerFormData) => {
  if (order.availableExtraProducts) {
    return order.travelers.map(({
      id,
      ...traveler
    }) => {
      var _traveler$firstName, _traveler$lastName;
      return {
        ...traveler,
        ...(id ? {
          id: Number(id)
        } : {}),
        initials: travelerUtils.getInitials((_traveler$firstName = traveler === null || traveler === void 0 ? void 0 : traveler.firstName) !== null && _traveler$firstName !== void 0 ? _traveler$firstName : '', (_traveler$lastName = traveler === null || traveler === void 0 ? void 0 : traveler.lastName) !== null && _traveler$lastName !== void 0 ? _traveler$lastName : ''),
        name: traveler.fullName
      };
    });
  }
  return order.travelers.map(traveler => {
    const currentTravelerNames = travelerFormNames.find(travelerFormName => travelerFormName.travelerId === traveler.id);
    const gender = traveler.id != null ? travelerFormData[Number(traveler.id)] : {};
    return {
      name: currentTravelerNames ? currentTravelerNames.fullName : string.insertArgument(defaultTravelerLabel, Number(traveler.id) + 1),
      id: Number(traveler.id),
      ageType: traveler.ageType,
      initials: (currentTravelerNames === null || currentTravelerNames === void 0 ? void 0 : currentTravelerNames.initials) || '',
      ...gender
    };
  });
};
//# sourceMappingURL=seatMapProductModalUtils.js.map